import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { productsAPI } from "../../services/productsService";
import { IProduct } from "../../Interfaces/interface.productsapi";
import { extractErrorMessage } from "utils/ErrorHandlers";

interface ProductDetailsState {
  product: IProduct | null;
  loading: boolean;
  error: string | null;
  isLoaded: boolean;
}

const initialState: ProductDetailsState = {
  product: null,
  loading: false,
  error: null,
  isLoaded: false,
};

export const fetchProductById = createAsyncThunk(
  "productDetails/fetchProductById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await productsAPI.fetchProductById(id);
      return response;
    } catch (error: any) {
      const message = extractErrorMessage(error);
      return rejectWithValue(message);
    }
  }
);

const productDetailsSlice = createSlice({
  name: "productDetails",
  initialState,
  reducers: {
    setProduct: (state, action: PayloadAction<IProduct>) => {
      state.product = action.payload;
      state.isLoaded = true;
      state.error = null;
      state.loading = false;
    },
    clearProduct: (state) => {
      state.product = null;
      state.isLoaded = false;
      state.loading = false;
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchProductById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchProductById.fulfilled,
        (state, action: PayloadAction<IProduct>) => {
          state.product = action.payload;
          state.loading = false;
          state.isLoaded = true;
        }
      )
      .addCase(fetchProductById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default productDetailsSlice.reducer;

export const { setProduct, clearProduct } = productDetailsSlice.actions;

export const selectProductDetails = (state: any) => state.productDetails;
export const selectProductDetailsLoading = (state: any) =>
  state.productDetails.loading;
export const selectProductDetailsError = (state: any) =>
  state.productDetails.error;
export const selectIsProductDetailsLoaded = (state: any) =>
  state.productDetails.isLoaded;
